<template>
  <section class="uploadWordPage">
    <popup v-show="isShowUploadVideo" bread="教材管理,课程管理,设置主题资料,编辑video" title="上传video" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="editUploadVideo">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑video'">
        <h3 class="group-tit">video资料</h3>
        <commonUploadVideo
          ref="ref_commonUploadWord"
          :key="timestamp"
          :max-number="(30-currentNumber)"
          :form.sync="uploadForm"
          code="dc"
          :label-name="'video'"
          :add-or-edit="'edit'"
          @formChange="commonUploadVideoChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonUploadVideo from '../components/commonUploadVideo'
import { editBasicMeans, addBasicMeans } from '@api/courseManagement/api_setThemeData'
import { mapState } from 'vuex'
import { functionData } from '../../../../utils/reg'
export default {
  components: {
    commonUploadVideo
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadVideo: false,
      commonUploadForm: {},
      uploadForm: {
        wordList: []
      }
    }
  },
  computed: {
    ...mapState('settingThemeData', ['naturalSpellingEditList', 'editVideoList'])
  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadVideo = true
      this.changeData(this.editVideoList)
    }
  },
  created () {

  },
  methods: {
    changeData(array) {
      console.log(array)
      const list = []
      for (const i in array) {
        const item = {
          wordName: array[i].wordName,
          id: array[i].id,
          img: functionData(array[i], 'cardChart', 'CardChart'),
          video: functionData(array[i], 'mouthShape', 'MouthShape'),
          key: Date.now()
        }
        list.push(item)
      }
      this.uploadForm.wordList = list
    },
    // 返回
    popup_back () {
      this.isShowUploadVideo = false
      // this.$emit('resetFetchData')
    },
    commonUploadVideoChange (form) {
      this.commonUploadForm = form
    },
    async editUploadVideo () {
      if (!this.$refs.ref_commonUploadWord.validateForm()) {
        this.$message.error('请正确填写信息')
        return false
      }
      const params = []
      for (const item of this.uploadForm.wordList) {
        params.push({
          wordName: item.wordName,
          cardChartName: item.img[0].paramsFileName || item.img[0].fileName,
          cardChartPath: item.img[0].matchPathName || item.img[0].paramsUrl,
          mouthShapeName: item.video[0].paramsFileName || item.video[0].fileName,
          mouthShapePath: item.video[0].matchPathName || item.video[0].paramsUrl,
          teachingThemeId: this.themeRow.id,
          meansType: 10,
          basicCode: 'VIDEO',
          isUse: '0',
          id: item.id
        })
      }
      try {
        await Promise.all(params.map(async (item) => {
          // 等待异步操作完成，返回执行结果
          if (item.id) {
            return await editBasicMeans({ basicMeansList: [item] })
          } else {
            return await addBasicMeans({ basicMeansList: [item] })
          }
        }))
        this.$message.success('编辑成功')
        this.isShowUploadVideo = false
        this.$emit('resetFetchData')
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    }

  }
}
</script>

<style lang='scss'>
.uploadWordPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
